import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { ThemeContext } from '../../../context/theme-context';
import COLORS from '../../../constants/color';


const ConstAnalysisAdvicePieChart = (props) => {// props: {chartData}

    const [chartData, setChartData] = useState([]);
    const [theme, setTheme] = useState('dark'); // ['dark', 'light'
    const currentTheme = useContext(ThemeContext).theme;

    useEffect(() => {
        setChartData(props.chartData);
        // setChartData(dummyChartdata);
        setTheme(currentTheme);
    }, [props]);


    useLayoutEffect(() => {
        let root = am5.Root.new("advice-pie-chart");
        root.setThemes([
            am5themes_Animated.new(root),
        ]);

        let chart = root.container.children.push(
            am5percent.PieChart.new(root, {
                endAngle: 270,
                layout: root.verticalLayout,

            })
        );

        let series = chart.series.push(
            am5percent.PieSeries.new(root, {
                name: "Series",
                valueField: "value",
                categoryField: "category",
                // legendLabelText: "{category}",
                // legendValueText: "{value}",
                endAngle: 270,
                tooltipText: "{category}: ({value})",
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{category}: ({value})",
                }),
                fill: am5.color("#fff"),
            })
        );

        series.labels.template.setAll({
            fontSize: 14,
            text: "{category}: ({value})",
            tooltipText: "{category}: ({value})",
            maxWidth: 150,
            oversizedBehavior: "wrap", // to truncate labels, use "truncate"
            fill: theme === 'dark' ? am5.color('#E0E0E0') : am5.color('#000'),
        });

        series.states.create("hidden", {
            endAngle: 190,

        });

        series.slices.template.setAll({
            fillOpacity: 1,
            stroke: am5.color(0xffffff),
            strokeWidth: 1,


        });

        series.slices.template.adapters.add("fill", function (fill, target) {
            var dataItem = target.dataItem;
            if (dataItem.get("category") == 'Tut') {
                target.set("tooltipY", am5.p100);
                return am5.color(COLORS.colorTut);
            }

            else if (dataItem.get("category") == 'Sat') {
                target.set("tooltipY", am5.p100);
                return am5.color(COLORS.colorSat);
            }

            else if (dataItem.get("category") == 'Al') {
                target.set("tooltipY", am5.p100);
                return am5.color(COLORS.colorAl);
            }

            else if (dataItem.get("category") == 'Kararsız') {
                target.set("tooltipY", am5.p100);
                return am5.color(COLORS.colorKararsiz);
            }

            return am5.color('#20E3B2');
        })


        series.data.setAll(chartData);

        // series.data.setAll(
        //     [
        //         {
        //             category: "Tut",
        //             value: 4
        //         }, {
        //             category: "Sat",
        //             value: 7
        //         },
        //         {
        //             category: "Al",
        //             value: 3
        //         }
        //     ]
        // );

        // Add legend
        // let legend = chart.children.push(am5.Legend.new(root, {
        //     centerX: am5.percent(50),
        //     centerY: am5.percent(10),
        //     x: am5.percent(50),
        //     layout: root.horizontalLayout,
        // }));
        // legend.maxHeight = 150;
        // legend.scrollable = true;
        // legend.data.setAll(series.dataItems);

        // let markerTemplate = legend.markers.template;
        // markerTemplate.width = 40;
        // markerTemplate.height = 40;

        series.appear(1000, 100);
        chart.appear(1000, 100);

        return () => {
            root.dispose();
        };

    }, [chartData, theme]);

    return (
        <div className='cons-analysis-pie-chart'>
            <div id="advice-pie-chart" style={{ width: "100%", height: "28rem", margin: 'auto' }}></div>
        </div>);
}

export default ConstAnalysisAdvicePieChart;




